<h1 mat-dialog-title>Solicitud de contacto</h1>
<div mat-dialog-content>
    <p>Nos contactaremos a la brevedad para gestionar la asistencia, mantenete atento al teléfono.</p>
</div>
<div mat-dialog-actions class="p-0 justify-content-end">
    <button mat-button color="accent" (click)="close()" cdkFocusInitial>Aceptar</button>
</div>